import { Component, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { GtrakAuthService } from '../../../authentication/services/gtrak-auth.service';
import { AccountManagementService } from '../../services/account-management.service';
import { ToasterService } from '../../../../common/services/toaster.service';


@Component({
  selector: 'app-manage-cost-center-page',
  templateUrl: 'manage-cost-center.page.html',
  styleUrls: [
    './manage-cost-center.page.scss',
    '../../styles/account-management.styles.scss',
  ],
})
export class ManageCostCenterPage implements OnInit, ViewWillEnter {
  loaded:boolean=false;
  currentRoute:string;
  login:string;
  available:any;
  assigned:any;
  searchAvailable = '';
  searchAssigned = '';
  selectedCC = '';
  selectAllAvailable = false;
  selectAllAssigned = false;
  selectedAvailable = new Set<string>();
  selectedAssigned = new Set<string>();
  availableCC: any[] = [];
  assignedCC: any[] = [];
  filteredAvailable: any[] = [];
  filteredAssigned: any[] = [];
  selectedAssigCostCenters:string[]=[];
  selectedAvaiCostCenter :string[]=[];
  custDetail:any;
   updatingSelectAll = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: GtrakAuthService,
    private accountService: AccountManagementService,
    private toasterService: ToasterService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit(): Promise<void> {
      this.loaded=false;
    if (!this.authService.user.canViewAccountManagement) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
     this.login = this.route.snapshot.params.login;
    this.currentRoute = this.router.url;
    await this.loadData();
      this.loaded=true;
  }

  async ionViewWillEnter() {
  
   
  }
  async loadData(){
    this.loaded=false;
    await this.getCostCenterAvailable();
    await this.getCostCenterAssigned();
    this.filteredAvailable = [...this.availableCC];
    this.filteredAssigned = [...this.assignedCC];
     this.loaded=true;
  }
  async getCostCenterAvailable(){
    this.loaded=false;
    var result= await this.accountService.GetCostCenterAvailable(this.login,this.searchAvailable);
    this.availableCC =result?.availableCostCenters;
    this.custDetail =result?.customerDetail;
    this.filteredAvailable = [...this.availableCC];
     this.loaded=true;
   }
   async getCostCenterAssigned(){
       this.loaded=false;
      this.assignedCC = await this.accountService.GetAssigmentItems(this.login,this.searchAssigned);
      this.filteredAssigned = [...this.assignedCC];
      this.loaded=true;
   }
 toggleAllAssigned() {
      if (this.selectAllAssigned) {
      this.filteredAssigned.forEach(cc =>
        this.selectedAssigned.add(cc.costCenterCode)
      );
   this.selectedAssigCostCenters=Array.from(this.selectedAssigned);
    } else {
      this.selectedAssigned.clear();
       this.selectedAssigCostCenters=[];
    }
  }
 toggleAllAvailable() {
  if (this.selectAllAvailable) {
      this.filteredAvailable.forEach(cc =>
        this.selectedAvailable.add(cc.costCenterCode)
      );
      this.selectedAvaiCostCenter=Array.from(this.selectedAvailable);
    } else {
      this.selectedAvailable.clear();
        this.selectedAvaiCostCenter=[];
    }
}

  clearAssigned() {
    this.searchAssigned = '';
    this.getCostCenterAssigned();
  }
  filterAvailable(event: any) {
      
      this.loaded=false;
      const value =
        event?.detail?.value ??
        event?.target?.value ??
        '';

  if (!value || value.length === 0) {
        this.searchAvailable="";
        this.getCostCenterAvailable();
       }
        this.loaded=true;
    }

    onEnterKeyAvailable(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getCostCenterAvailable();
    }
     onEnterKeyAssigned(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getCostCenterAssigned();
    }
  filterAssigned(event: any) {
     this.loaded=false;
     this.loaded=false;
      const value =
        event?.detail?.value ??
        event?.target?.value ??
        '';

      if (!value || value.length === 0) {
            this.searchAssigned="";
            this.getCostCenterAssigned();
          }
        this.loaded=true;
  }
  async addCostCenter() {
    this.selectAllAvailable=false;
    this.selectAllAssigned=false;
    
    if(this.selectedAvaiCostCenter.length!=0){
      
      var result= await this.accountService.AddCostCenter(this.selectedAvaiCostCenter,this.custDetail.customerCode,this.custDetail.login);
      if(result){
        this.selectedAvaiCostCenter=[];
        this.loadData();
        this.toasterService.presentToast(
          'primary',
          '',
          "Successfully Coster Center Added",
          1000
        );
      }
      else{
        this.toasterService.presentToast(
          'danger',
          '',
          'error',
          1000
        );
      }
    }
    else{
        this.toasterService.presentToast(
          'danger',
          '',
          'Please select cost center.',
          1000
        );
      }
  }
 
onSelectAllChange(checked: boolean) {
  if (this.updatingSelectAll) {
    return; 
  }

  this.selectAllAvailable = checked;

  if (checked) {
    this.selectedAvaiCostCenter = this.filteredAvailable.map(
      cc => cc.costCenterCode
    );
  } else {
    this.selectedAvaiCostCenter = [];
  }
}

onAssigCheckboxChange(code: string, checked: boolean) {
  if (checked) {
    if (!this.selectedAssigCostCenters.includes(code)) {
      this.selectedAssigCostCenters.push(code);
    }
  } else {
    this.selectedAssigCostCenters =
      this.selectedAssigCostCenters.filter(c => c !== code);
  }
}
  
onAvaiCheckboxChange(code: string, checked: boolean) {
  if (checked) {
    if (!this.selectedAvaiCostCenter.includes(code)) {
      this.selectedAvaiCostCenter.push(code);
    }
  } else {
    this.selectedAvaiCostCenter =
      this.selectedAvaiCostCenter.filter(c => c !== code);
  }

  // Update Select All WITHOUT triggering its change logic
  this.updatingSelectAll = true;
  this.selectAllAvailable =
    this.filteredAvailable.length > 0 &&
    this.filteredAvailable.every(cc =>
      this.selectedAvaiCostCenter.includes(cc.costCenterCode)
    );
  this.updatingSelectAll = false;
}

  async removeCostCenter() {
    
    this.selectAllAvailable=false;
    this.selectAllAssigned=false;
    if(this.selectedAssigCostCenters.length!=0){
      
      var result= await this.accountService.RemoveCostCenter(this.selectedAssigCostCenters,this.custDetail.customerCode,this.custDetail.login);
     if(result){
      this.selectedAssigCostCenters=[];
        this.loadData();
        this.toasterService.presentToast(
          'primary',
          '',
          "Successfully Cost Center Removed",
          1000
        );
      }
      else{
        this.toasterService.presentToast(
          'danger',
          '',
          'error',
          1000
        );
      }
 
    }
      else{
        this.toasterService.presentToast(
          'danger',
          '',
          'Please select cost center.',
          1000
        );
      }
  }
  clearAvailable() {
      this.searchAvailable="";
      this.getCostCenterAvailable();
    }

}